import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  sdohData: {},
  statesConfig: {},
  selectedOptions: {options: {}},
  specialGeographicIndicators: [],
  disableSdohOptions: [],
  childCareDisableState: [],
  toggleOptionsForExport: {options: {}},
  removedAndResetFilters: {
    removed: [],
    reset: []
  }
}

const sdohSlice = createSlice({
  name: 'sdoh',
  initialState,
  reducers: {
    setSdohData: (state, action) => {
      state.sdohData = action.payload
    },
    updateSdohDataImmer: (state, action) => {
      // Action payload is a function that modifies the draft
      action.payload(state.sdohData)
    },
    setStatesConfig: (state, action) => {
      state.statesConfig = action.payload
    },
    setSelectedOptions: (state, action) => {
      state.selectedOptions = action.payload
    },
    updateSelectedOptionsImmer: (state, action) => {
      // Ensure options property exists
      if (!state.selectedOptions.options) {
        state.selectedOptions.options = {}
      }
      action.payload(state.selectedOptions)
    },
    setSpecialGeographicIndicators: (state, action) => {
      state.specialGeographicIndicators = action.payload
    },
    setDisableSdohOptions: (state, action) => {
      state.disableSdohOptions = action.payload
    },
    setChildCareDisableState: (state, action) => {
      state.childCareDisableState = action.payload
    },
    setToggleOptionsForExport: (state, action) => {
      state.toggleOptionsForExport = action.payload
    },
    updateToggleOptionsForExportImmer: (state, action) => {
      // Ensure options property exists
      if (!state.toggleOptionsForExport.options) {
        state.toggleOptionsForExport.options = {}
      }
      action.payload(state.toggleOptionsForExport)
    },
    setRemovedAndResetFilters: (state, action) => {
      state.removedAndResetFilters = action.payload
    },
    updateRemovedAndResetFiltersImmer: (state, action) => {
      action.payload(state.removedAndResetFilters)
    }
  }
})

export const {
  setSdohData,
  updateSdohDataImmer,
  setStatesConfig,
  setSelectedOptions,
  updateSelectedOptionsImmer,
  setSpecialGeographicIndicators,
  setDisableSdohOptions,
  setChildCareDisableState,
  setToggleOptionsForExport,
  updateToggleOptionsForExportImmer,
  setRemovedAndResetFilters,
  updateRemovedAndResetFiltersImmer
} = sdohSlice.actions

export const selectSdohData = (state) => state.sdoh.sdohData
export const selectStatesConfig = (state) => state.sdoh.statesConfig
export const selectSelectedOptions = (state) => state.sdoh.selectedOptions
export const selectSpecialGeographicIndicators = (state) => state.sdoh.specialGeographicIndicators
export const selectDisableSdohOptions = (state) => state.sdoh.disableSdohOptions
export const selectChildCareDisableState = (state) => state.sdoh.childCareDisableState
export const selectToggleOptionsForExport = (state) => state.sdoh.toggleOptionsForExport
export const selectRemovedAndResetFilters = (state) => state.sdoh.removedAndResetFilters

export default sdohSlice.reducer
